import { isRouteErrorResponse,useRouteError } from 'react-router-dom';

import { Callout } from '@ekhodealer/ekho-common/rev';

export default function RouteErrorBoundary() {
	const error = useRouteError();

	let errorMessage: string;
	let errorTitle = 'Something went wrong';

	if (isRouteErrorResponse(error)) {
		// This is a route error from React Router
		errorTitle = `${error.status} ${error.statusText}`;
		errorMessage = error.data?.message || 'An unexpected error occurred';
	} else if (error instanceof Error) {
		// This is a JavaScript Error object
		errorMessage = error.message;
	} else if (typeof error === 'string') {
		// This is a string error
		errorMessage = error;
	} else {
		// Unknown error type
		errorMessage = 'An unknown error occurred';
	}

	return (
		<div role='alert' style={{ padding: 16 }}>
			<div>
				<Callout
					title={errorTitle}
					message={errorMessage}
					variant='error'
					appearance='filled'></Callout>
				{process.env.NODE_ENV !== 'production' && error instanceof Error && (
					<pre style={{ marginTop: 16, whiteSpace: 'pre-wrap' }}>{error.stack}</pre>
				)}
			</div>
		</div>
	);
}
